
import React, { Fragment } from "react";

import SweetAlert from 'sweetalert2';
import { toast } from "react-toastify";

import { bannersService } from 'Services';
import TableRowDelete from 'CommonElements/Table/TableRowDelete';


const DeleteBanner = ({ data={}, loadData }) => {


  const deleteBanner = () => {
    SweetAlert.fire({
        title: 'Are you sure?',
        text: 'Once deleted, you will not be able to recover this record!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'cancel',
        reverseButtons: true,
    }).then((result) => {
        if (result.value) {
            bannersService.deleteBanner(data.id).then(res => {
                toast.success('Banner deleted, successfully');
                loadData();
            }).catch(err => {
                toast.error('Failed to delete Banner');

            })
        }
    });
};
  return (
    <Fragment>
        <TableRowDelete onClick={deleteBanner} />

    </Fragment>
  );
};

export default DeleteBanner;
